//Images are stored in public folder
class Images {
  // LOGOUT = "/img/logout.png";
}

export default Images;
